import { apiClient } from "../apiClient";
import { PriorityCard } from "../../types/collab-docs/coach";

const BASE = "dashboards/ai-coach";

class aiCoachApi {
  constructor(private accessToken: string | undefined) {}

  async getCards(
    answerSetUniqueId: string,
    isManager: boolean,
  ): Promise<PriorityCard[] | null> {
    try {
      const data = await apiClient(
        this.accessToken,
        `${BASE}/cards?answerSetUniqueId=${answerSetUniqueId}&isManager=${isManager}`,
        { method: "GET" },
      );
      return (data as PriorityCard[]) ?? [];
    } catch {
      return null;
    }
  }

  async generate(
    answerSetUniqueId: string,
    isManager: boolean,
  ): Promise<{ cards: PriorityCard[] } | "RATE_LIMITED" | null> {
    try {
      const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/${BASE}/generate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          body: JSON.stringify({ answerSetUniqueId, isManager }),
        },
      );

      if (response.status === 429) return "RATE_LIMITED";
      if (!response.ok) return null;

      return (await response.json()) as { cards: PriorityCard[] };
    } catch {
      return null;
    }
  }

  async updateCardStatus(
    cardId: number,
    status: "DISCUSSED" | "DISMISSED",
  ): Promise<void> {
    await apiClient(this.accessToken, `${BASE}/cards/${cardId}/status`, {
      method: "PATCH",
      body: JSON.stringify({ status }),
    });
  }

  async createFeedback(
    cardId: number,
    value: "UP" | "DOWN",
  ): Promise<{ feedbackId: number } | null> {
    try {
      return await apiClient(this.accessToken, `${BASE}/feedback`, {
        body: JSON.stringify({ cardId, value }),
      });
    } catch {
      return null;
    }
  }

  async updateFeedbackText(feedbackId: number, text: string): Promise<void> {
    await apiClient(this.accessToken, `${BASE}/feedback/${feedbackId}`, {
      method: "PATCH",
      body: JSON.stringify({ text }),
    });
  }
}

export default aiCoachApi;
